import { render } from "./carruselfina_ingles.vue?vue&type=template&id=1aa66d40&scoped=true"
import script from "./carruselfina_ingles.vue?vue&type=script&lang=js"
export * from "./carruselfina_ingles.vue?vue&type=script&lang=js"

import "./carruselfina_ingles.vue?vue&type=style&index=0&id=1aa66d40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa66d40"]])

export default __exports__